(() => {
  const displayCount = (value) => {
    if (value === null || value === undefined) return '';
    let text = String(value).trim();
    if (!text) return '';
    text = text
      .replace(/\bminimum\b/gi, '')
      .replace(/\bseeds?\b/gi, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
    return text;
  };

  const setupSeedCount = (root) => {
    if (!root || root.dataset.aonskCountReady === 'true') return;
    root.dataset.aonskCountReady = 'true';

    const dataNode = root.querySelector('[data-aonsk-seed-count-data]');
    const countNode = root.querySelector('[data-aonsk-seed-count-value]');
    const labelNode = root.querySelector('[data-aonsk-seed-count-label]');
    if (!dataNode || !countNode) return;

    let payload = {};
    try {
      payload = JSON.parse(dataNode.textContent || '{}');
    } catch (_) {
      return;
    }

    const update = (variantId) => {
      const variantCount = payload.variants && payload.variants[String(variantId)];
      const value = variantCount !== null && variantCount !== undefined && String(variantCount).trim() !== ''
        ? variantCount
        : payload.productCount;
      const display = displayCount(value);

      if (display) {
        countNode.textContent = display;
        if (labelNode) labelNode.textContent = 'minimum seeds';
        root.classList.remove('is-missing-count');
      } else {
        countNode.textContent = 'Check option';
        if (labelNode) labelNode.textContent = 'packet quantity';
        root.classList.add('is-missing-count');
      }
    };

    const form = document.querySelector('.js-product-form-main');
    const idInput = form && form.querySelector('[name="id"]');
    update(idInput && idInput.value ? idInput.value : '');

    document.addEventListener('variant:changed', (event) => {
      const variant = event.detail && event.detail.variant;
      if (variant && variant.id) update(variant.id);
    });

    document.addEventListener('shopify:variant:change', (event) => {
      const variant = event.detail && event.detail.variant;
      if (variant && variant.id) update(variant.id);
    });

    if (form) {
      form.addEventListener('change', () => {
        const input = form.querySelector('[name="id"]');
        if (input && input.value) update(input.value);
      });
    }
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-aonsk-seed-count]').forEach(setupSeedCount);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
